import { SignalSource } from 'data/SignalSource';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import { getSignalAt } from 'state/Store';
import { getCSSVarValue } from 'utils';

interface Props {
  signal: SignalSource;
  inverted?: boolean;
  selected?: boolean;
}

export const MotionSignalSelectBackground: React.FunctionComponent<Props> = (
  props: Props
) => {
  const canvas = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvas.current) {
      const invert = props.inverted || false;
      const selected = props.selected || false;
      let { width, height } = canvas.current.getBoundingClientRect();
      const scale = 2; // window.devicePixelRatio;
      width *= scale;
      height *= scale;
      // console.log(`render: ${width}x${height}`);
      canvas.current.width = width;
      canvas.current.height = height;
      const ctx = canvas.current.getContext('2d');
      const style = selected
        ? getCSSVarValue('--accent-color')
        : getCSSVarValue('--menu-color');
      if (ctx) {
        ctx.save();
        // ctx.globalAlpha = 0.3;
        ctx.clearRect(0, 0, width, height);
        ctx.strokeStyle = style;
        const lineWidth = 1 / scale;
        ctx.lineWidth = lineWidth;
        for (var x = 0; x < width; x += lineWidth) {
          const pos = x / width;
          let level = getSignalAt(props.signal, pos);
          if (invert) {
            level = 1 - level;
          }
          const h = height * level;
          ctx.beginPath();
          ctx.moveTo(x, height - h);
          ctx.lineTo(x, height);
          ctx.stroke();
        }
        ctx.restore();
      }
    }
  });

  return <canvas ref={canvas} />;
};



// WEBPACK FOOTER //
// ./src/components/MotionSignalSelectBackground.tsx